export default __webpack_public_path__ + "static/media/flag-red.220c5df4.svg";